var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmallOverWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 140,
    viewBox: "0 0 104 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.629756 138.183C1.27421 125.318 0.698805 101.986 0.629756 89.3523C0.261494 69.4789 -2.47745 42.7813 7.3045 24.637C19.5262 3.93366 45.4426 -4.57363 68.0447 2.38898C81.4172 6.28527 93.2706 15.807 99.0937 28.5794C113.479 59.3809 94.8818 96.1535 60.9096 100.926C55.869 101.595 50.5983 101.71 45.5577 101.087C43.3021 100.649 40.333 100.442 38.3996 99.1507C38.0313 90.7817 38.3996 81.3753 38.2845 72.9372L39.3433 72.2916C58.654 83.3811 80.8418 67.9804 76.883 45.9859C73.2003 27.8647 52.3705 19.8646 37.3408 30.4469C31.4717 34.5737 27.2597 41.5133 27.1446 48.7756C27.1446 75.0121 27.0986 103.001 27.0756 129.26C25.7636 130.874 23.2318 131.059 21.4596 132.027C18.9968 133.041 16.5571 134.263 14.1173 135.347C11.0101 136.73 7.81086 138.114 4.61159 139.289C3.52982 139.589 2.30995 140.235 1.18215 139.912C0.975001 139.428 0.79087 138.69 0.606739 138.229L0.629756 138.183Z",
    fill: "url(#paint0_linear_809_3914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_809_3914",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A50BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallOverWhite);
export default __webpack_public_path__ + "static/media/logo_small_over_white.7e3e5b6162080e762d1b5339cb788934.svg";
export { ForwardRef as ReactComponent };